import type { BuilderPropertyRecord } from '../tool-defaults';
import { LabeledCheckboxRow, LabeledNumberRow, LabeledTextRow } from './field-primitives';

export function ToleranceField({ tolerance, onPatch }: { tolerance: string; onPatch: (patch: BuilderPropertyRecord) => void }) {
    return (
        <LabeledTextRow
            label="Tolerance (Absolute or percent. Ex: 3 or 3%)"
            value={tolerance}
            rows={1}
            monospace
            onValueChange={v => onPatch({ tolerance: v })}
        />
    );
}

export function WidthField({ width, onPatch }: { width: number; onPatch: (patch: BuilderPropertyRecord) => void }) {
    return (
        <LabeledNumberRow
            label="Width"
            placeholder="Ex: 125"
            value={width}
            onIntChange={n => onPatch({ width: n })}
        />
    );
}

export function AbsoluteValueCheckbox({
    absoluteValue,
    onPatch,
}: {
    absoluteValue: boolean;
    onPatch: (patch: BuilderPropertyRecord) => void;
}) {
    return (
        <LabeledCheckboxRow
            label="Absolute numerical value"
            checked={absoluteValue}
            onCheckedChange={v => onPatch({ absolute_value: v })}
        />
    );
}
